import { Mediator, app, payload } from "modular-openscriptjs";
import { api, uc, gc } from "../declarations";
import { routes } from "../backendRoutes";
import { eParse, approved } from "../helpers";

const $e = app("$e");

export class SubscriptionMediator extends Mediator {
    $$subscription = {
        needs: {
            active: () => this.getActiveSubscription(),
            plans: (ed) => this.getPlans(ed),
            subscribe: (ed) => this.subscribe(ed),
            cancel: (ed) => this.cancelSubscription(ed),
        },
    };

    $$user = {
        authenticated_loggedOut: () => this.getActiveSubscription(),
    };

    $$order = {
        placed: () => this.getActiveSubscription(),
    };

    async getActiveSubscription() {
        if (!gc.auth.value) {
            uc.subscription.value = {};
            return;
        }

        let res = await api.get(
            `${routes.subscriptions}/active`,
            {},
            { silent: true },
        );

        if (res && res.data) {
            uc.subscription.value = res.data.subscription;

            this.send(
                $e.subscription.has.active,
                payload({ subscription: res.data.subscription }),
            );
        } else {
            uc.subscription.value = {};
            this.send($e.subscription.has.active);
        }
    }

    async getPlans(ed) {
        let res = await api.get(`${routes.subscriptions}/plans`);

        if (!res) {
            return;
        }

        this.send(
            $e.subscription.has.plans,
            payload({ plans: res.data.plans }),
        );
    }

    async subscribe(ed) {
        let { message } = eParse(ed);
        let planId = message.plan_id;
        let trialId = message.trial_id;
        let method = message.method;
        let information = message.information;

        let res = await api.post(routes.subscriptions, {
            plan_id: planId,
            trial_id: trialId,
            method: method,
            information: information
        });

        if (res && res.data) {
            uc.subscription.value = res.data.subscription;
            this.send(
                $e.subscription.has.active,
                payload({ subscription: res.data.subscription }),
            );
            this.send($e.capa.needs.balance);
        }
    }

    async cancelSubscription(ed) {
        if (!approved($e.subscription.needs.cancel, ed, "Are you sure you want to cancel your subscription?")) {
            return;
        }

        let res = await api.post(`${routes.subscriptions}/cancel`);

        if (res && res.data) {
            this.send($e.subscription.cancelled);
            await this.getActiveSubscription();
        }
    }
}
